import type { Option } from "./Select";

/** Empty / placeholder row (e.g. "Select an answer…") — not a real selection. */
export function isEmptyPlaceholderOption(option: Pick<Option, "value">): boolean {
    return option.value === "" || option.value == null;
}

export function hasRealSelectValue(value: string[]): boolean {
    return value.some((v) => v !== "" && v != null);
}

/** Whether list item should use selected styling (not placeholder, value matches). */
export function isListOptionSelected(option: Option, value: string[]): boolean {
    return hasRealSelectValue(value) && !isEmptyPlaceholderOption(option) && value.includes(option.value);
}
